// userHandlers.ts
import { message } from "antd";
import type { AxiosError } from "axios";
import {
  performUserAction,
  addPlatformUser,

  resetUserPassword,
} from "src/services/AdminPortalAPIs";


// Reusable handler functions

export const getHandleSuspend = (
  user: any,
  setModalData: any,
  setModalOpen: any,
  fetchUsers: () => Promise<void>
) => {
  const isAdmin = user.role === "Admin";

  setModalData({
    title: `Suspend ${user.name}?`,
    description: isAdmin
      ? "Suspending an admin will suspend all its users. Do you want to continue?"
      : "This will prevent the user from accessing the platform until reactivated. Do you want to continue?",
    icon: "/Icons/suspend-user.svg",
    confirmText: isAdmin ? "Suspend Admin" : "Suspend User",
    cancelText: "Cancel",
    onConfirm: async () => {
      try {
        const payload = { user_id: user.user_id, suspend: true };
        const res = await performUserAction(payload);
        if (res?.data?.status) {
          message.success("User suspended successfully");
          await fetchUsers();
        } else {
          message.error(res?.data?.message || "Failed to suspend user");
        }
      } catch (err: unknown) {
        const error = err as AxiosError<any>;
        message.error(
          error?.response?.data?.detail ||
            error?.response?.data?.message ||
            "Error suspending user"
        );
      } finally {
        setModalOpen(false);
      }
    },
  });

  setModalOpen(true);
};

export const getHandleDelete = (
  user: any,
  setModalData: any,
  setModalOpen: any,
  fetchUsers: () => Promise<void>
) => {
  const isAdmin = user.role === "Admin";

  setModalData({
    title: `Delete ${user.name}?`,
    description: isAdmin
      ? "Deleting an admin will delete all its users. Do you want to continue?"
      : "This action will remove the user from the platform. Do you want to continue?",
    icon: "/Icons/admindelete-user.svg",
    confirmText: isAdmin ? "Delete Admin" : "Delete User",
    cancelText: "Cancel",
    onConfirm: async () => {
      try {
        const payload = {
          user_id: user.user_id,
          user_name: user.name,
          status: user.status,
          delete: true,
        };
        const res = await performUserAction(payload);
        if (res?.data?.status) {
          message.success("User deleted successfully");
          await fetchUsers();
        } else {
          message.error(res?.data?.message || "Failed to delete user");
        }
      } catch (err: unknown) {
        const error = err as AxiosError<any>;
        const msg =
          error?.response?.data?.detail ||
          error?.response?.data?.message ||
          "Error deleting user";
        message.error(msg);
        console.error("Delete error:", error);
      } finally {
        setModalOpen(false);
      }
    },
  });

  setModalOpen(true);
};

export const handleAddUserSubmit = async (
  values: any,
  setAddUserModalOpen: any,
  fetchUsers: () => Promise<void>
) => {
const payload = {
  user_name: values.user_name,
  user_email: values.user_email,
  tenant_email: values.tenant_email,
  status: values.status,
};

  try {
    const res = await addPlatformUser(payload);
    if (res?.data?.status) {
      message.success("User added successfully !");
      setAddUserModalOpen(false);
      await fetchUsers();
    } else {
      message.error(
  res?.data?.detail?.msg ||
    res?.data?.message?.msg ||
    res?.data?.detail ||
    res?.data?.message ||
    "Failed to add user !"
);
    }
  } catch (err: unknown) {
    const error = err as AxiosError<any>;
    message.error(
      error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Something went wrong. Please try again."
    );
  }
};

export const handleResetPassword = async (email: string) => {
  try {
    const res = await resetUserPassword(email);
    if (res?.data?.status) {
      message.success("Password reset email sent successfully.");
    } else {
      message.error(res?.data?.message || "Failed to reset password.");
    }
  } catch (err: unknown) {
    const error = err as AxiosError<any>;
    const errorMsg =
      error?.response?.data?.detail ||
      error?.response?.data?.message ||
      "Something went wrong.";
    message.error(errorMsg);
  }
};
